import { CSSProperties, makeAppStyles } from '@percept/mui'

export const cardLoadingStyles: Record<'card' | 'refetchIndicator', CSSProperties> = {
  card: {
    position: 'relative',
  },
  refetchIndicator: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: 4,
    width: '100%',
  }
}

export const useCardLoadingStyles = makeAppStyles(cardLoadingStyles)
